import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Typography,
  Col,
  Row,
  Tooltip,
  Spin,
  Table,
  Collapse,
  BackTop,
  Menu,
  Dropdown,
} from 'antd';
import styles from '../../../../shared-components/Recipe/recipe.module.sass';
import local_styles from './hostinginfrastructureASNs.module.sass';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
//import { InfoCircleFilled } from '@ant-design/icons';
import Icon, {
  InfoCircleFilled,
  LoadingOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import {
  infoNotification,
  showNotification,
} from '../../../../shared-components/Notifications';
import moment from 'moment-timezone';
import store from '../../../../redux/store';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
import SavedRecipeModal from '../../../../shared-components/SavedRecipeModal';
import useModalNameValidator from '../../../../redux/utils/useModalNameValidator';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { highlightLeftMenu } from '../../../../redux/actions/leftMenu';
import { Link } from 'react-router-dom';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { ReactComponent as no_results } from '../../../../assets/icons/no_results.svg';
import { ReactComponent as no_results_filled } from '../../../../assets/icons/no_results_filled.svg';
import cx from 'classnames';
import _ from 'lodash';
import HostingInfrastructureASNsResult from '../HostingInfrastructureASNsExploreRecipe/ResultsTable';
import { validateRecipeDomainName } from '../../../../shared-components/Validation/RecipeDomainName';
import DeleteRecipeModal from '../../../../shared-components/DeleteRecipeModal';
import { JSONViewer } from '../../../../shared-components/JSONViewer';
import {
  exportHostingInfrasctructureASNsToCSV,
  exportHostingInfrasctructureASNsToJSON,
} from '../../../../redux/actions/ioc';
import { BackToTopButton } from '../../../../shared-components/BackToTopButton';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

const { Panel } = Collapse;

function HostingInfrastructureASNQuery(props) {
  mixpanel.track('Global Nav - Hosting Infrastructure ASN', {
    location: window.location.href,
  });
  const {
    exploreRecipeHostingInfrastructureASNs,
    recipeDataStatusHostingInfrastructureASNs,
    exploreRecipeDataHostingInfrastructureASNs,

    exploreRecipeSpoofing,
    loadMergeAPIRiskScores,
    loadMergeAPIASNDetails,
    loadUser,
    loadSources,
    createEmptySource,
    createFileSource,
    updateFileSource,
    addIOCJson,
    clearExploreDetails,
    loadScoreDetails,
    loadMergeAPIExploreRecipe,
    loadMergeAPIEnrichment,
    loadMergeAPIIPDetails,
    loadMergeAPIDomainDetails,
    loadMergeAPIExploreDetails,
    loadMergeAPIMergeDetails,
    loadMergeAPIExploreAnyIPDetails,
    loadMergeAPIExploreDensity,
    loadMergeAPIWhoisDetails,
    loadMergeAPIDomainInfraTags,
    loadIPEditableFeeds,
    loadDomainEditableFeeds,
    loadURLEditableFeeds,
    searchForTags,
    resetTagSearch,
    saveMonitoringQuery,
    loadResultFile,
    loadHistoryQueryResult,
    exportExploreResultToCSV,
    exportExploreResultToJSON,
    exportHostingInfrasctructureASNsToCSV,
    exportHostingInfrasctructureASNsToJSON,
    exportSingleIOC,
    resetEnrichment,
    loadMySubscriptionPlan,
    saveBreadCrumbs,
    queryNameInTXTRecipe,

    user,
    sources,
    exploreFilters,
    exploreSorting,
    status,
    scoreDetails,
    mergeAPIEnrichment,
    mergeAPIscoreDetails,
    exploreAPIscoreDetails: exploreAPIscoreDetails,
    mergeAPIData: mergeAPIData,
    exploreAPIANYIPscoreDetails: exploreAPIANYIPscoreDetails,
    exploreAPIANYIPJobID: exploreAPIANYIPJobID,
    exploreAPIDensityDetails: exploreAPIDensityDetails,
    exploreAPIDensityStatus: exploreAPIDensityStatus,
    exploreAPIwhoisDetails: exploreAPIwhoisDetails,
    infraTagStatus: infraTagStatus,
    domainInfraTags: domainInfraTags,
    whoisStatus: whoisStatus,
    IPEditableFeeds: IPEditableFeeds,
    IPEditableFeedsStatus: IPEditableFeedsStatus,
    DomainEditableFeeds: DomainEditableFeeds,
    DomainEditableFeedsStatus: DomainEditableFeedsStatus,
    URLEditableFeeds: URLEditableFeeds,
    URLEditableFeedsStatus: URLEditableFeedsStatus,
    foundTags: foundTags,
    searchStatus: searchStatus,
    riskScoreStatus: riskScoreStatus,
    exploreRiskScores: exploreRiskScores,
    exploreASNStatus: exploreASNStatus,
    exploreASNDetails: exploreASNDetails,
    mySubscriptionPlan: mySubscriptionPlan,
    mySubscriptionPlanStatus: mySubscriptionPlanStatus,
    breadcrumbs: breadcrumbs,
    loadBrandImpersonationRecipeResults,
    // loadDanglingDNSDetectionRecipeResults,
    loadHostingInfrastructureASNsRecipeResults,
    clearRecipe,
  } = props;

  const PrettyPrintJson = React.memo(({ data }) => (
    <div style={{ textAlign: 'left' }}>
      <JSONViewer data={data} />
    </div>
  ));

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  function copyRawData(data) {
    navigator.clipboard.writeText(JSON.stringify(data));
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  function copyAPIURL(data) {
    navigator.clipboard.writeText(data);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  const q = useQuery();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [saveModalType, setSaveModalType] = useState('saveNew');
  const isSaveModalValid = useModalNameValidator(nameOfNewQuery);
  const { Paragraph, Text, Title } = Typography;
  const titleText = q?.get('left_menu_name') || 'Hosting Infrastructure - ASNs';
  const threatNameValue = Form.useWatch('threat_name', form);

  const [searchQuery, setSearchQuery] = useState('');
  const ClearFilters = (props) => <Icon component={no_results} {...props} />;
  const ClearFiltersFilled = (props) => (
    <Icon component={no_results_filled} {...props} />
  );
  const NoDataIcon = (props) => <Icon component={no_results} {...props} />;

  const [activeCollapseKey, setActiveCollapseKey] = useState(['1']);

  const openAllCollapse = () => {
    setActiveCollapseKey(['1', '2']);
  };

  const toggleCollapse = (key) => {
    if (activeCollapseKey?.includes(key)) {
      setActiveCollapseKey(activeCollapseKey?.filter((k) => k !== key));
    } else {
      setActiveCollapseKey([...activeCollapseKey, key]);
    }
  };

  const recipeInitCollapse = () => {
    setActiveCollapseKey(['1']);
  };

  const searchActionCollapse = () => {
    setActiveCollapseKey(['2']);
  };

  useEffect(() => {
    document.title = `${titleText} - Silent Push`;
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetRecipeStatus();
    props.clearExploreDetails();
    form.resetFields();
    recipeInitCollapse();
    setSearchQuery('');

    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeHostingInfrastructureASNs(
        q?.get('recipeid'),
      );
    }
    dispatch(changeTitle(titleText, null));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.resetRecipeStatus();
    form.resetFields();
    recipeInitCollapse();
    setSaveModalType('saveNew');
    setSearchQuery('');
    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeHostingInfrastructureASNs(
        q?.get('recipeid'),
      );
    }
  }, [window.location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (clearRecipe === true) {
      document.title = `${titleText} - Silent Push`;
      props.clearExploreDetails();
      props.saveBreadCrumbs(null);
      props.loadUser();
      props.loadMySubscriptionPlan();
      props.resetRecipeStatus();
      props.clearExploreDetails();
      form.resetFields();
      recipeInitCollapse();
      setSearchQuery('');
      props.unsetClearRecipe();
    }
  }, [clearRecipe]); // eslint-disable-line react-hooks/exhaustive-deps

  function resetForm() {
    form.resetFields();
    props.resetRecipeStatus();
    recipeInitCollapse();
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    setSearchQuery('');
    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeHostingInfrastructureASNs(
        q?.get('recipeid'),
      );
    }
  }

  function FormHeader() {
    return (
      <div
        // style={{ marginBottom: '-7px' }}
        //className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('1')}
      >
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
          // className={styles.title}
        >
          Query Form
        </Title>
      </div>
    );
  }

  function ResultsHeader() {
    return (
      <div
        // style={{ marginBottom: '-7px' }}
        //className={cx(styles.header, styles.only_text_header)}
        onClick={() => toggleCollapse('2')}
      >
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
          // className={styles.title}
        >
          Query Results
        </Title>
      </div>
    );
  }

  useEffect(() => {
    // form.resetFields();
    dispatch(
      changeTitle(
        props?.exploreRecipeHostingInfrastructureASNs?.name ?? titleText,
        null,
      ),
    );
    document.title = `${titleText} - Silent Push`;
    if (
      props.recipeStatusHostingInfrastructureASNs == STATUS.LOADED &&
      props?.exploreRecipeHostingInfrastructureASNs?.name
    ) {
      document.title = `${props?.exploreRecipeHostingInfrastructureASNs?.name} - Silent Push`;
    }
    // }, [props.exploreRecipeHostingInfrastructureASNs]); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    if (window.location.href.includes('/explore/hosting-infra-asns')) {
      if (
        props?.exploreRecipeHostingInfrastructureASNs?.uuid &&
        window.location.href.indexOf(
          '/explore/hosting-infra-asns?recipeid=' +
            props?.exploreRecipeHostingInfrastructureASNs?.uuid,
        ) == -1
      ) {
        history.push(
          '/explore/hosting-infra-asns?recipeid=' +
            props?.exploreRecipeHostingInfrastructureASNs?.uuid,
        );
        dispatch(
          highlightLeftMenu(
            props?.exploreRecipeHostingInfrastructureASNs?.uuid,
          ),
        );
      }
      form.resetFields();
      form.setFieldsValue({
        threat_name: exploreRecipeHostingInfrastructureASNs?.domain,
        type: exploreRecipeHostingInfrastructureASNs?.query_type,
        window: exploreRecipeHostingInfrastructureASNs?.window,
      });
    }
  }, [props.exploreRecipeHostingInfrastructureASNs]);

  const handleCancel = () => {
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function changeScopeRecipe() {
    props.changeScopeMergeAPIExploreRecipeHostingInfrastructureASNs({
      scope:
        props?.exploreRecipeHostingInfrastructureASNs?.scope === 'USER'
          ? 'ORGANISATION'
          : 'USER',
      uuid: props?.exploreRecipeHostingInfrastructureASNs?.uuid,
    });
    incrementUIRequestsCounter();
  }

  function returnUiRecipeData(values, type) {
    if (type === 'saveAs') {
      return {
        new_name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeHostingInfrastructureASNs?.name,
        new_description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeHostingInfrastructureASNs?.description,
      };
    } else {
      return {
        name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeHostingInfrastructureASNs?.name,
        description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeHostingInfrastructureASNs?.description,
        domain: values?.threat_name,
        uuid: q?.get('recipeid'),
      };
    }
  }

  function updateButtonDisabled() {
    if (exploreRecipeHostingInfrastructureASNs?.domain !== threatNameValue) {
      return false;
    } else {
      if (threatNameValue === undefined) {
        return false;
      }
      return true;
    }
  }

  const handleOk = (type) => {
    form
      .validateFields()
      .then((values) => {
        if (saveModalType === 'edit' || type === 'edit') {
          props.updateMergeAPIExploreRecipeHostingInfrastructureASNs(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveNew' || type === 'saveNew') {
          props.saveMergeAPIExploreRecipeHostingInfrastructureASNs(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveAs' || type === 'saveAs') {
          props.cloneRecipe(
            returnUiRecipeData(values, type),
            'hosting-infra-asns-recipes',
            q?.get('recipeid'),
          );
        }
        incrementUIRequestsCounter();
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  const handleDeleteRecipe = () => {
    props.deleteMergeAPIExploreRecipeHostingInfrastructureASNs(
      q?.get('recipeid'),
    );
    props.resetRecipeStatus();
    props.clearExploreDetails();
    props.history.push(
      '/explore/hosting-infra-asns/?left_menu_name=Hosting Infrastructure - ASNs',
    );
    setIsDeleteModalVisible(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
  };

  const DropdownMenu = () => {
    return (
      <Menu>
        {
          <>
            {((q?.get('recipeid') &&
              props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                  'ORGANISATION' &&
                props?.exploreRecipeHostingInfrastructureASNs?.is_mine ===
                  true)) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('edit');
                  setIsModalVisible(true);
                }}
              >
                Edit Metadata
              </Menu.Item>
            )}

            {((q?.get('recipeid') &&
              props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                  'ORGANISATION')) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('saveAs');
                  setIsModalVisible(true);
                }}
              >
                Save As
              </Menu.Item>
            )}

            <Tooltip
              title={
                props.mySubscriptionPlan?.has_access_to_share_unshare ? (
                  ''
                ) : (
                  <>
                    Sharing option is not part of this subscription plan. To
                    upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                )
              }
            >
              {((q?.get('recipeid') &&
                props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                  'USER') ||
                (q?.get('recipeid') &&
                  props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                    'ORGANISATION' &&
                  props?.exploreRecipeHostingInfrastructureASNs?.is_mine ===
                    true)) && (
                <Menu.Item onClick={() => changeScopeRecipe()}>
                  {props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                  'ORGANISATION'
                    ? 'Unshare'
                    : 'Share'}
                </Menu.Item>
              )}
            </Tooltip>

            {((q?.get('recipeid') &&
              props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                  'ORGANISATION' &&
                props?.exploreRecipeHostingInfrastructureASNs?.is_mine ===
                  true)) && (
              <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
                <span style={{ color: 'red' }}>Delete</span>
              </Menu.Item>
            )}
          </>
        }
      </Menu>
    );
  };

  function renderPane() {
    return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
      props.mySubscriptionPlan?.has_access_to_hosting_infra_asns_recipe ? (
        props.recipeStatusHostingInfrastructureASNs !== STATUS.LOADING ? (
          <div className={styles.explore_recipe}>
            <Row gutter={24}>
              <Col xs={24} className={styles.header}>
                <div
                  data-cy="hostingInfrastructureASNsRecipeQueryFormChip"
                  className={threat_detail_styles['type-chip']}
                >
                  {titleText}
                </div>

                <div className={styles.recipeDescription}>
                  <Paragraph
                    data-cy="hostingInfrastructureASNsRecipeQueryFormDescription"
                    className="m-0"
                  >
                    {exploreRecipeHostingInfrastructureASNs?.description
                      ? exploreRecipeHostingInfrastructureASNs.description
                      : 'Obtain the ASNs that have been used by A records associated with a given domain (including its subdomains) within the last 30 days.'}{' '}
                  </Paragraph>

                  <Link
                    to={{
                      pathname:
                        'https://help.silentpush.com/docs/scan-for-asn-associated-with-a-domain-and-subdomains',
                    }}
                    target="_blank"
                  >
                    Knowledge Base
                  </Link>
                </div>

                <div className={styles.action_buttons}>
                  <Tooltip
                    title={
                      updateButtonDisabled() ? 'Form values unchanged.' : ''
                    }
                  >
                    <Button
                      disabled={updateButtonDisabled()}
                      role={'button1'}
                      onClick={() => {
                        if (
                          saveModalType === 'saveNew' &&
                          !q?.get('recipeid')
                        ) {
                          form
                            .validateFields()
                            .then((values) => {
                              setNameOfNewQuery('');
                              setDescriptionOfNewQuery('');
                              setSaveModalType('saveNew');
                              setIsModalVisible(true);
                            })
                            .catch((errorInfo) => {});
                        } else {
                          handleOk('edit');
                        }
                      }}
                    >
                      {q?.get('recipeid') ? 'Update' : 'Save'}
                    </Button>
                  </Tooltip>

                  {((q?.get('recipeid') &&
                    props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                      'USER') ||
                    (q?.get('recipeid') &&
                      props?.exploreRecipeHostingInfrastructureASNs?.scope ===
                        'ORGANISATION')) && (
                    <Dropdown trigger={['click']} overlay={DropdownMenu({})}>
                      <MoreOutlined className={styles.dropdown_icon} />
                    </Dropdown>
                  )}
                </div>
              </Col>
            </Row>

            <Tooltip title="Go to the top of the page">
              <BackToTopButton />
            </Tooltip>

            <div className={cx('collapse_row_recipe')}>
              <Collapse
                defaultActiveKey={['1']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={FormHeader()} key="1">
                  <Form
                    className={styles.form}
                    form={form}
                    name="explore"
                    initialValues={{
                      threat_name:
                        exploreRecipeHostingInfrastructureASNs?.domain,
                      type: exploreRecipeHostingInfrastructureASNs?.query_type,
                      window: exploreRecipeHostingInfrastructureASNs?.window,
                    }}
                    onFinish={(values) => {
                      if (values?.threat_name) {
                        const threat = values?.threat_name?.replace(' ', '');
                        props.saveBreadCrumbs(null);

                        setSearchQuery(
                          `/explore-result?name=${threat}&queryType=hosting_infrastructure_asn&type=hosting_infrastructure_asn&fromQueryBuilder=true&backLink=${encodeURIComponent(
                            window.location.pathname,
                          )}${encodeURIComponent(
                            window.location.search,
                          )}&originalQueryURL=padns%2Flookup%2Fdomain%2Fasns%2F${threat}%3Fresult_format%3Dfull%26max_wait%3D25%26with_metadata%3D1&origin_uid=HOSTING_INFRA_ASNS`,
                        );
                      }
                      searchActionCollapse();
                      setTimeout(() => {
                        window.scrollTo(0, 0);
                      }, '10');
                    }}
                  >
                    <Row gutter={36}>
                      <Col xs={24}>
                        <Title level={5}>
                          Domain *{' '}
                          <Tooltip
                            placement="top"
                            title="Enter a domain name. Subdomains are included in the search. Wildcards are not supported"
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Title>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Text data-cy="hostingInfrastructureASNsRecipeQueryFormDomainNameLabel">
                          Domain Name
                        </Text>
                        <Form.Item
                          name="threat_name"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(fieldObject, fieldValue) {
                                const validation = validateRecipeDomainName(
                                  fieldValue,
                                  titleText,
                                );

                                if (validation.valid) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(validation?.message);
                                }
                              },
                            }),
                          ]}
                        >
                          <Input
                            data-cy="hostingInfrastructureASNsRecipeQueryFormDomainNameInput"
                            maxLength={255}
                            placeholder="Enter Domain Name"
                          />
                        </Form.Item>

                        <div className={styles.bottom_actions}>
                          <Form.Item>
                            <Tooltip
                              title={
                                props.mySubscriptionPlan
                                  ?.has_access_to_explore ? (
                                  ''
                                ) : (
                                  <>
                                    This option is not part of this subscription
                                    plan. To upgrade your subscription contact
                                    us at{' '}
                                    <a
                                      target="_blank"
                                      href="mailto:sales@silentpush.com"
                                    >
                                      sales@silentpush.com
                                    </a>
                                    .
                                  </>
                                )
                              }
                            >
                              <Button
                                disabled={
                                  !props.mySubscriptionPlan
                                    ?.has_access_to_explore
                                }
                                role={'button2'}
                                type="primary"
                                htmlType="submit"
                              >
                                Search
                              </Button>
                            </Tooltip>
                          </Form.Item>

                          <Button type="text" onClick={() => resetForm()}>
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Panel>
              </Collapse>
            </div>

            <div className={cx('collapse_row_recipe')}>
              <Collapse
                defaultActiveKey={['2']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={ResultsHeader()} key="2">
                  <div>
                    {searchQuery ? (
                      <HostingInfrastructureASNsResult
                        searchQuery={searchQuery}
                        mySubscriptionPlanStatus={
                          props.mySubscriptionPlanStatus
                        }
                        mySubscriptionPlan={props.mySubscriptionPlan}
                        loadMergeAPIRiskScores={loadMergeAPIRiskScores}
                        loadMergeAPIASNDetails={loadMergeAPIASNDetails}
                        loadUser={loadUser}
                        loadSources={loadSources}
                        createEmptySource={createEmptySource}
                        createFileSource={createFileSource}
                        updateFileSource={updateFileSource}
                        addIOCJson={addIOCJson}
                        clearExploreDetails={clearExploreDetails}
                        loadScoreDetails={loadScoreDetails}
                        loadMergeAPIExploreRecipe={loadMergeAPIExploreRecipe}
                        loadMergeAPIEnrichment={loadMergeAPIEnrichment}
                        loadMergeAPIIPDetails={loadMergeAPIIPDetails}
                        loadMergeAPIDomainDetails={loadMergeAPIDomainDetails}
                        loadMergeAPIExploreDetails={loadMergeAPIExploreDetails}
                        loadMergeAPIMergeDetails={loadMergeAPIMergeDetails}
                        loadMergeAPIExploreAnyIPDetails={
                          loadMergeAPIExploreAnyIPDetails
                        }
                        loadMergeAPIExploreDensity={loadMergeAPIExploreDensity}
                        loadMergeAPIWhoisDetails={loadMergeAPIWhoisDetails}
                        loadMergeAPIDomainInfraTags={
                          loadMergeAPIDomainInfraTags
                        }
                        loadIPEditableFeeds={loadIPEditableFeeds}
                        loadDomainEditableFeeds={loadDomainEditableFeeds}
                        loadURLEditableFeeds={loadURLEditableFeeds}
                        searchForTags={searchForTags}
                        resetTagSearch={resetTagSearch}
                        saveMonitoringQuery={saveMonitoringQuery}
                        loadResultFile={loadResultFile}
                        loadHistoryQueryResult={loadHistoryQueryResult}
                        exportExploreResultToCSV={exportExploreResultToCSV}
                        exportExploreResultToJSON={exportExploreResultToJSON}
                        exportHostingInfrasctructureASNsToCSV={
                          exportHostingInfrasctructureASNsToCSV
                        }
                        exportHostingInfrasctructureASNsToJSON={
                          exportHostingInfrasctructureASNsToJSON
                        }
                        exportSingleIOC={exportSingleIOC}
                        resetEnrichment={resetEnrichment}
                        loadMySubscriptionPlan={loadMySubscriptionPlan}
                        saveBreadCrumbs={saveBreadCrumbs}
                        queryNameInTXTRecipe={queryNameInTXTRecipe}
                        user={user}
                        //sources
                        exploreFilters={exploreFilters}
                        exploreSorting={exploreSorting}
                        status={status}
                        scoreDetails={scoreDetails}
                        mergeAPIEnrichment={mergeAPIEnrichment}
                        mergeAPIscoreDetails={mergeAPIscoreDetails}
                        exploreAPIscoreDetails={exploreAPIscoreDetails}
                        mergeAPIData={mergeAPIData}
                        exploreAPIANYIPscoreDetails={
                          exploreAPIANYIPscoreDetails
                        }
                        exploreAPIANYIPJobID={exploreAPIANYIPJobID}
                        exploreAPIDensityDetails={exploreAPIDensityDetails}
                        exploreAPIDensityStatus={exploreAPIDensityStatus}
                        exploreAPIwhoisDetails={exploreAPIwhoisDetails}
                        infraTagStatus={infraTagStatus}
                        domainInfraTags={domainInfraTags}
                        whoisStatus={whoisStatus}
                        IPEditableFeeds={IPEditableFeeds}
                        IPEditableFeedsStatus={IPEditableFeedsStatus}
                        DomainEditableFeeds={DomainEditableFeeds}
                        DomainEditableFeedsStatus={DomainEditableFeedsStatus}
                        URLEditableFeeds={URLEditableFeeds}
                        URLEditableFeedsStatus={URLEditableFeedsStatus}
                        foundTags={foundTags}
                        searchStatus={searchStatus}
                        riskScoreStatus={riskScoreStatus}
                        exploreRiskScores={exploreRiskScores}
                        exploreASNStatus={exploreASNStatus}
                        exploreASNDetails={exploreASNDetails}
                        breadcrumbs={breadcrumbs}
                        loadBrandImpersonationRecipeResults={
                          loadBrandImpersonationRecipeResults
                        }
                        loadHostingInfrastructureASNsRecipeResults={
                          loadHostingInfrastructureASNsRecipeResults
                        }
                        websocketConnection={props?.websocketConnection}
                      />
                    ) : (
                      <div className={styles.empty_state}>
                        <NoDataIcon
                          style={{ fontSize: 32, marginTop: '8px' }}
                        />
                        <Title level={4}>Query didn't run</Title>

                        <Text>
                          For the results you need to fill out the query form
                          and click Search.
                        </Text>
                      </div>
                    )}
                  </div>
                  {/* </Col> */}
                  {/* </Row> */}
                </Panel>
              </Collapse>
              {/* </Col> */}
            </div>
          </div>
        ) : (
          <LoadingSilentPush size={80} positionCenter />
        )
      ) : (
        <PermissionDeniedPage />
      )
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }

  return (
    <>
      <SavedRecipeModal
        isModalVisible={isModalVisible}
        isSaveModalValid={isSaveModalValid}
        handleOk={handleOk}
        handleCancel={handleCancel}
        nameOfNewQuery={nameOfNewQuery}
        setNameOfNewQuery={setNameOfNewQuery}
        descriptionOfNewQuery={descriptionOfNewQuery}
        setDescriptionOfNewQuery={setDescriptionOfNewQuery}
        type={saveModalType}
        loadedRecipe={exploreRecipeHostingInfrastructureASNs}
      />
      <DeleteRecipeModal
        isDeleteModalVisible={isDeleteModalVisible}
        handleOk={handleDeleteRecipe}
        handleCancel={handleDeleteCancel}
        loadedRecipe={exploreRecipeHostingInfrastructureASNs}
      />
      {renderPane()}
      <VersionCheck
        parentComponentStatus={
          q?.get('recipeid')
            ? props.recipeStatusHostingInfrastructureASNs
            : STATUS.LOADED
        }
      />
    </>
  );
}

export default HostingInfrastructureASNQuery;
